$(document).ready(function() {
  $(document).on('click', function(event) {
    if ($(window).width() > 812 && !$(event.target).closest('.vertical-menu').length) {
      $('.nav-bar').removeClass('active');
      $('.menu-mb-translate').removeClass('sub-menu-open');
    }
  });

  $(document).on('click','.cart-side-btn',function(e){
    e.preventDefault();
    var mainHtml = document.querySelector('html');
    (mainHtml.classList.contains('cart-show'))?mainHtml.classList.remove('cart-show'):mainHtml.classList.add('cart-show');
  });
  
//   mmenu script start
  $(function() {

    new Mmenu("#menu2", {
      extensions 	: [ "position-bottom", "fullscreen",  "border-full" ],
      navbars		: [{
        height 	: 2,
        content : [
          '<a href="tel:02085142356" class="fa fa-phone"></a>',
          '<img src="https://cdn.shopify.com/s/files/1/0270/7157/8246/files/Kugans_Logo.png" />',
          '<a href="mailto:info@kugans.com" class="fa fa-envelope"></a>'
        ]
      },
      {
		"position": "bottom",
		"content": [
			"<a class='' href='/pages/contact-us'>NEED HELP?</a>",
			"<a class='' href='/pages/faq1'>STORE FAQ'S</a>",
			"<a class='' href='/account'>MY ACCOUNT</a>",
			"<a class='' href='/pages/wish-list'>WISH LIST</a>"
		]
      },   
	  {
		"position": "bottom",
		"content": [
			"<a class='brands-new' href='/pages/brands'><span>BRANDS</span><label class='new-label'><span>New</span></label></a>",
			"<a class='offer-new' href='/'><span>OFFERS</span><label class='sale-label'><span>Sale</span></label></a>",
			"<a class='blog' href='/blogs/categories'>BLOG</a>",
			"<a class='' href='/pages/compare'>ADD TO COMPARE</a>"
		]
	  },
	  {
		content: [ "searchfield" ]
	  }, 
	  {
		content : ["prev","title"]
	  }],
      searchfield: {
        "search": false
      }
    }, 
	{
      "searchfield": {
        "submit" : true,
        "form": {
          "action" : "/search?type=product",
          "method" : "get"
        },
        "input" : {
          "name" : "q"
        }
      }
    }       
	);
  });

  $(document).ready(function() {
    jQuery('#menu2 .mm-searchfield').append('<input type="hidden" name="type" value="product"/>');
  }); 
//   mmenu script end
 
//   Brands Filter script start
  function brandItemCounter() {
    if($('.mb-brands').length){
      $('.mb-brands li input').each(function(i,t) {
        var burl = window.location.origin + window.location.pathname + '?constraint=' + t.value + '&view=item-count';
        $.get(burl, function(pg) {
          var cls = '.' + t.value + ' .count_label';
          $(cls).html("<span>"+pg+"</span>");
        });
      });
    }
  }

  //brandItemCounter();
//   Brands Filter script end
  if ($(window).width() < 767){
  $(document).on('click', '.pagination-page a', function () {
    var elm = $('.container .breadcrumb');

    if (!elm.length) {
      elm = $('[data-search-page]');
    }

    var top = elm.offset().top;
    $('body,html').animate({scrollTop: top}, 600);
  });
  }


  
});
